// PageHead - the title block that sits above a page's content. Ported from
// botriq-admin-fe's Robot Portal UI kit so My Robots' header reads the same
// way Fleet's does: icon badge + title + subtitle on the left, actions
// right-aligned (wrapping to their own row on narrow screens).
import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import { Icon } from "./Icon";

export const PageHead = ({ title, sub, icon, actions, sx }) => (
  <Box sx={{ mb: 2, minWidth: 0, ...sx }}>
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "stretch", sm: "center" }}
      justifyContent="space-between"
      gap={1.5}
    >
      <Stack direction="row" alignItems="center" gap={1.5} sx={{ minWidth: 0 }}>
        {icon && (
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "10px",
              flex: "none",
              display: "grid",
              placeItems: "center",
              background: "var(--bq-accentSoft)",
              color: "var(--bq-accent)",
            }}
          >
            <Icon name={icon} size={20} />
          </Box>
        )}
        <Box sx={{ minWidth: 0 }}>
          <Typography
            component="h1"
            sx={{
              fontSize: 20,
              fontWeight: 700,
              letterSpacing: "-.02em",
              color: "var(--bq-text)",
              lineHeight: 1.2,
              m: 0,
            }}
          >
            {title}
          </Typography>
          {sub && (
            <Typography sx={{ fontSize: 13, color: "var(--bq-text2)", mt: 0.25 }}>{sub}</Typography>
          )}
        </Box>
      </Stack>

      {actions && (
        <Stack
          direction="row"
          alignItems="center"
          gap={1.5}
          flexWrap="wrap"
          justifyContent={{ xs: "flex-start", sm: "flex-end" }}
        >
          {actions}
        </Stack>
      )}
    </Stack>
  </Box>
);

PageHead.propTypes = {
  title: PropTypes.node.isRequired,
  sub: PropTypes.node,
  icon: PropTypes.string,
  actions: PropTypes.node,
  sx: PropTypes.object,
};

export default PageHead;
